<a *ngIf = "!!cmsResponse && !!imageUrl" href="unsafe:javascript:void(0)" rel="{{redirectionLink}}" type="{{type}}" class="app-navigation-links" [ngClass] = "{'disable-Link' : !redirectionLink}">
    <section>
        <img src="{{ imageUrl }}" alt="img" />
    </section>
</a>
